<div *ngIf="activeCustomer$ | async as customer">
    <div *ngIf="cart$ | async as cart" class="cart-toggle">
        <button
            class="cart-toggle__button"
            (click)="toggle.emit()"
            title="cart"
            aria-label="Open cart"
        >
            <span class="cart-toggle__main">
                <img
                    alt=""
                    class="cart-toggle__icon"
                    src="../../../../assets/icons/cart-icon.svg"
                />
                <span class="cart-toggle__label">Cart</span>
            </span>
            <span
                [class.empty]="cart.quantity === 0"
                [class.cart-changed]="cartChangeIndication$ | async"
                class="cart-toggle__badge"
            >
                {{ cart.quantity }}
            </span>
        </button>
    </div>
</div>
